import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=c79f1b68&scoped=true&"
import script from "./Cgu.vue?vue&type=script&lang=js&"
export * from "./Cgu.vue?vue&type=script&lang=js&"
import style0 from "./Cgu.vue?vue&type=style&index=0&id=c79f1b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79f1b68",
  null
  
)

export default component.exports